import {ClientError} from 'graphql-request';

export const throwErrorMessage = (error: unknown) => {
  console.log(error, 'error');
  if (error instanceof ClientError) {
    console.log(error, 'error', 'Client');
    throw new Error(
      error.response.errors?.[0]?.message ??
        `GraphQL Error (Code: ${String(error.response.status)})`
    );
  }

  if (error instanceof Error) {
    console.log(error, 'error', 'Error');
    throw new Error(error?.message);
  }

  if (typeof error === 'string') {
    console.log(error, 'error', 'String');
    throw new Error(error);
  }

  throw new Error('Unknown error');
};
